import resetMixin from "@/helper/resetForm";
import tokenClear from "@/helper/eraseToken";
import axios from "axios";

export const npbu = {
    mixins: [resetMixin, tokenClear],
    data() {
        return {
            // variable pembantu
            helper: {
                errors: [],
                disableSimpan: false
            },
            // loading
            isLoading: false,
            buttonDisable: false,
            // tombol selanjutnya
            buttonNext: false
        };
    },
    methods: {
        // store data npbu
        async store() {
            try {
                this.isLoading = true;
                this.buttonDisable = true;
                // item 'nama' di rubah ke huruf besar
                this.form.nama = this.form.nama.toUpperCase();
                let response = await this.form.post("/api/bumd/npbu");
                this.isLoading = false;
                this.buttonDisable = false;
                this.helper.disableSimpan = true;
                const items = response.data.data;
                // jenis condition
                this.buttonNext = true;
                // vuex disable step
                this.editMode = true;
                // input ke localstorage untuk id npbu
                localStorage.setItem(
                    "npbu_id",
                    JSON.stringify(items.id)
                );
                this.user.npbu_id = items.id;
                localStorage.setItem("user", JSON.stringify(this.user));
                this.$swal({
                    icon: "success",
                    title: "Data berhasil ditambah",
                    type: "success",
                    confirmButtonClass: "btn btn-info",
                    showConfirmButton: true,
                    showCloseButton: true,
                    confirmButtonText: "OKE",
                    allowOutsideClick: false,
                    timer: 5000
                });
                this.reload();
            } catch (error) {
                this.isLoading = false;
                this.buttonDisable = false;
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data;
                } else {
                    console.log(error);
                }
            }
        },
        // update data pangkat
        async update(id) {
            try {
                this.isLoading = true;
                this.buttonDisable = true;
                // item 'nama' di rubah ke huruf besar
                this.form.nama = this.form.nama.toUpperCase();
                let response = await this.form.put("/api/bumd/npbu/" + id);
                if (this.form.successful) {
                    this.isLoading = false;
                    this.buttonDisable = false;
                    const items = response.data.data;
                    // jenis condition
                    if (items.jenis > 41) {
                        this.buttonNext = false;
                        // vuex disable step
                        // this.$store.dispatch("Npbu/inputStep", false);
                    } else {
                        this.buttonNext = true;
                        // vuex disable step
                        // this.$store.dispatch("Npbu/inputStep", false);
                    }
                    this.$swal({
                        icon: "success",
                        title: "Data berhasil dirubah",
                        type: "success",
                        confirmButtonClass: "btn btn-info",
                        showConfirmButton: true,
                        showCloseButton: true,
                        confirmButtonText: "OKE",
                        allowOutsideClick: false,
                        timer: 5000
                    });
                    this.reload();
                    // input ke localstorage untuk id npbu
                    localStorage.setItem(
                        "npbu_id",
                        JSON.stringify(items.id)
                    );
                    this.user.npbu_id = items.id;
                    localStorage.setItem("user", JSON.stringify(this.user));
                } else {
                    this.isLoading = false;
                    this.buttonDisable = false;
                    this.buttonNext = true;
                    this.$swal({
                        icon: "error",
                        title: "Terjadi Masalah.",
                        confirmButtonClass: "btn btn-info",
                        showConfirmButton: true,
                        showCloseButton: true,
                        confirmButtonText: "OKE",
                        allowOutsideClick: false,
                        timer: 5000
                    });
                }
            } catch (error) {
                this.isLoading = false
                if (error.response.status == 422) {
                    this.helper.errors = error.response.data;
                } else {
                    console.log(error);
                }
            }
        },
        // detail data pangkat
        async detail(id) {
            try {
                let response = await axios.get("/api/bumd/npbu/" + id);
                const items = response.data.data;
                this.editMode = true
                // ketika masuk ke halaman detail npbu
                if (this.$route.name == "DetailNpbu") {
                    // variabel diambil dari component '/views/detail_npbu/DetailNpbu
                    this.detailNpbu = items;
                } else {
                    // apabila di halaman dashboard
                    if (this.$route.name == 'Profil') {
                        // jika status registrasi = 5 maka redirect ke dashboard
                        if (items.status_registrasi_id == 5) {
                            this.$router.push({ name: "Dashboard" });
                            localStorage.setItem('status_registrasi', true)
                        } else if (items.status_registrasi) {
                            localStorage.setItem('status_registrasi', false)
                            // vuex - menampilkan data status registrasi pada halaman dashboard
                            this.$store.commit('Npbu/inputStatus', items.status_registrasi )
                        }
                    }
                    // input data ke form
                    this.form.fill(items);
                    // variabel untuk disable jenis
                    this.helper.disableSimpan = true;
                    // jika badan atau perorangan
                    if (this.form.jenis < 41) {
                        this.form.jenis = "Badan";
                        this.buttonNext = true;
                    } else {
                        this.form.jenis = "Perorangan";
                        this.$store.commit("Npbu/inputStep", true);
                    }
                    // data wilayah
                    if (items.wilayah_kelurahan) {
                        this.wilayah.provinsi =
                            items.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota.wilayah_provinsi_id;
                        // vuex - call data kabkota by id provinsi
                        this.$store.dispatch(
                            "Wilayah/getKabkota",
                            this.wilayah.provinsi
                        );
                        this.wilayah.kabkota =
                            items.wilayah_kelurahan.wilayah_kecamatan.wilayah_kabkota_id;
                        // vuex - call data kecamatan by id kabkota
                        this.$store.dispatch(
                            "Wilayah/getKecamatan",
                            this.wilayah.kabkota
                        );
                        this.wilayah.kecamatan =
                            items.wilayah_kelurahan.wilayah_kecamatan_id;
                        // vuex - call data kelurahan by id kecamatan
                        this.$store.dispatch(
                            "Wilayah/getKelurahan",
                            this.wilayah.kecamatan
                        );
                        this.form.wilayah_kelurahan_id = Number(
                            items.wilayah_kelurahan_id
                        );
                    }
                }
            } catch (error) {
                if (error.response.status == 401) {
                    this.tokenClear();
                } else {
                    console.log(error);
                }
            }
        },
    }
};

export default npbu;
